import { useProgressReportApi } from '@api/disciplines/progress-reports/report.hook'
import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'

import { show404 } from '@utils/pages/error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const progressReportId: string | null = to?.params?.report as string || null
  onDisciplineReady(() => {
    void useProgressReportApi({ progressReportId }, {
      onError: () => {
        return show404()
      },
    })
  }, { hook: 'NONE' })
})
